export default function* processError(err) {
  yield console.error(err); // eslint-disable-line
}
